import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    /**
     * Emits true when access token has been retrieved.
     */
    public tokenReady$ = new BehaviorSubject<boolean>(false);

    private token = '';

    getToken(): string {
        return this.token;
    }

    setToken(token: string): void {
        this.tokenReady$.next(token !== '');
        this.token = token;
    }
}
